import styled from "styled-components";

export const AppsHeaderContainer = styled.div`
  width: 100%;
  padding: 1.6rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 2.2rem;
  line-height: 2.6rem;
  color: #0096c6;
  letter-spacing: 0.1px;
  text-transform: capitalize;
  position: relative;
  margin-bottom: 1.4rem;
  &::after {
    content: "";
    position: absolute;
    width: Calc(100% - 0.4rem);
    height: 1px;
    background: #ffffff33;
    bottom: 0;
    left: 0.2rem;
  }
`;

export const AppsContainerLot = styled.div`
  width: 100%;
  height: 22.8rem;
  position: relative;
`;

export const AppsContainer = styled.div`
  display: flex;
  align-items: center;
  overflow-x: scroll;
  position: absolute;
  width: Calc(100% + 16rem);
  left: -8rem;
  padding: 0 5rem 0.8rem 8rem;
`;